import React, { useCallback, useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import { toast } from 'react-toastify'
import { format } from 'date-fns'
import { FiFileText, FiFile } from 'react-icons/fi'

import Yup from '../../../../../services/yup'
import { api, authHeaders } from '../../../../../services/api'
import ibge from '../../../../../services/ibge'

import { downloadRelatorioJasper } from '../../../../../util/file'

import {
    Button, Select, Calendar
} from '../../../../../components/Form'
import Spinner from '../../../../../components/Spinner'

import { Container, ButtonContainer } from './styles'

import rangeDayGif from '../../../../../assets/images/gifs/periodo-dias.gif'
import rangeMonthGif from '../../../../../assets/images/gifs/periodo-mes.gif'

const initialValues = {
    'plano-saude-status': '',
    juridico: '',
    cidade: '',
    competencia: '',
    instituicao: '',
    'data-nascimento': '',
    aniversario: ''
}

const validation = Yup.object().shape({
    'plano-saude-status': Yup.object({ label: Yup.string(), value: Yup.mixed() }),
    juridico: Yup.object({ label: Yup.string(), value: Yup.mixed() }),
    cidade: Yup.object({ label: Yup.string(), value: Yup.mixed() }),
    competencia: Yup.string().nullable().required('Informe o periodo de competencia para a busca.'),
    instituicao: Yup.object({ label: Yup.string(), value: Yup.mixed() }),
    'data-nascimento': Yup.string().nullable(),
    aniversario: Yup.string().nullable()
})

const nomeRelatorio = 'Relatório de membros quites'

export default function (props) {
    const [cidades, setCidades] = useState([])
    const [instituicoes, setInstituicoes] = useState([])
    const [isSubmittingPlanilha, setIsSubmittingPlanilha] = useState(false)

    useEffect(() => {
        async function loadCidades() {
            const { data } = await ibge.get('estados/PA/municipios')

            setCidades(data.map(({ nome }) => nome).sort())
        }

        loadCidades()
    }, [])

    useEffect(() => {
        async function loadInstituicoes() {
            const response = await api.get('instituicao', {
                params: {
                    type: 'banco'
                }
            })

            setInstituicoes(response)
        }

        loadInstituicoes()
    }, [])

    const handleSubmit = useCallback(async (values, { resetForm }) => {
        const {
            cidade,
            'data-nascimento': nascimento,
            aniversario,
            competencia,
            'plano-saude-status': planoSaudeStatus,
            juridico,
            instituicao
        } = values

        const nascimentoInicio = nascimento ? nascimento[0] : null
        const nascimentoFim = nascimento ? nascimento[1] : null
        const aniversarioInicio = aniversario ? aniversario[0] : null
        const aniversarioFim = aniversario ? aniversario[1] : null

        let filtros = ''

        if (nascimentoInicio) {
            filtros += `Data nasc.: ${format(new Date(nascimentoInicio), 'dd/MM/yyyy')} a ${nascimentoFim !== null ? format(new Date(nascimentoFim), 'dd/MM/yyyy') : format(new Date(nascimentoInicio), 'dd/MM/yyyy')}, `
        }

        if (aniversarioInicio) {
            filtros += `Aniversário: ${format(new Date(aniversarioInicio), 'dd/MM/yyyy')} a ${aniversarioFim !== null ? format(new Date(aniversarioFim), 'dd/MM/yyyy') : format(new Date(aniversarioInicio), 'dd/MM/yyyy')}, `
        }

        if (instituicao) {
            filtros += `Instituição: ${instituicao.label}, `
        }

        if (cidade) {
            filtros += `Cidade: ${cidade.label}, `
        }

        if (planoSaudeStatus) {
            filtros += `${planoSaudeStatus.value === 1 ? 'Com plano de saúde' : 'Sem plano de Saúde'}, `
        }

        if (juridico) {
            filtros += `${juridico.value === 1 ? 'Com causa no jurídico' : 'Sem causa no jurídico'}, `
        }

        try {
            const response = await api.post('relatorio', {
                relatorio: 'RelatorioContribuicaoQuites',
                parametros: {
                    cidade: cidade?.value || '',
                    competencia: format(new Date(competencia), 'yyyy-MM-dd'),
                    dataNascimentoInicio: nascimentoInicio !== null ? format(new Date(nascimentoInicio), 'yyyy-MM-dd') : '',
                    dataNascimentoFim: nascimentoFim !== null ? format(new Date(nascimentoFim), 'yyyy-MM-dd') : (nascimentoInicio !== null) ? format(new Date(nascimentoInicio), 'yyyy-MM-dd') : '',
                    dataAniversarioInicio: aniversarioInicio !== null ? format(new Date(aniversarioInicio), 'yyyy-MM-dd') : '',
                    dataAniversarioFim: aniversarioFim !== null ? format(new Date(aniversarioFim), 'yyyy-MM-dd') : (aniversarioInicio !== null) ? format(new Date(aniversarioInicio), 'yyyy-MM-dd') : '',
                    juridico: juridico?.value || '',
                    instituicao: instituicao?.value || '',
                    planodeSaude: planoSaudeStatus?.value || '',
                    filtros: filtros !== '' ? filtros.slice(0, -2) : ''
                }
            }, {
                ...authHeaders(),
                responseType: 'blob'
            })

            downloadRelatorioJasper(response, nomeRelatorio)

            resetForm()
        } catch (e) {
            toast.error('Erro ao gerar o relatório.')
        }
    }, [])

    const handleSubmitPlanilha = useCallback(async (values, resetForm) => {
        setIsSubmittingPlanilha(true)

        const {
            cidade,
            'data-nascimento': nascimento,
            aniversario,
            competencia,
            'plano-saude-status': planoSaudeStatus,
            juridico,
            instituicao
        } = values

        const nascimentoInicio = nascimento ? nascimento[0] : null
        const nascimentoFim = nascimento ? nascimento[1] : null
        const aniversarioInicio = aniversario ? aniversario[0] : null
        const aniversarioFim = aniversario ? aniversario[1] : null

        try {
            const response = await api.post('/relatorio/contribuicao_quites_excel', {
                relatorio: 'RelatorioQuites',
                parametros: {
                    cidade: cidade?.value || null,
                    competencia: competencia !== null ? format(new Date(competencia), 'yyyy-MM-dd') : null,
                    dataNascimentoInicio: nascimentoInicio !== null ? format(new Date(nascimentoInicio), 'yyyy-MM-dd') : null,
                    dataNascimentoFim: nascimentoFim !== null ? format(new Date(nascimentoFim), 'yyyy-MM-dd') : (nascimentoInicio !== null) ? format(new Date(nascimentoInicio), 'yyyy-MM-dd') : null,
                    dataAniversarioInicio: aniversarioInicio !== null ? format(new Date(aniversarioInicio), 'yyyy-MM-dd') : null,
                    dataAniversarioFim: aniversarioFim !== null ? format(new Date(aniversarioFim), 'yyyy-MM-dd') : (aniversarioInicio !== null) ? format(new Date(aniversarioInicio), 'yyyy-MM-dd') : null,
                    planoSaude: planoSaudeStatus?.value || null,
                    juridico: juridico?.value || null,
                    instituicao: instituicao?.value || null
                }
            }, {
                ...authHeaders(),
                responseType: 'blob'
            })

            if (response.type === 'application/json') {
                const fr = new FileReader()

                fr.onload = function (e) {
                    const json = e.target.result
                    toast.warn(JSON.parse(json).msg)
                }
                fr.readAsText(response)
            } else {
                downloadRelatorioJasper(response, nomeRelatorio, 'xlsx')
            }

            resetForm()
        } catch (e) {
            console.log(e)
            toast.error('Erro ao gerar o relatório.')
        }

        setIsSubmittingPlanilha(false)
    }, [])

    return (
        <Container className="animated fadeIn faster form" {...props}>
            <Formik
                initialValues={initialValues}
                validationSchema={validation}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({
                    isSubmitting, setFieldValue, resetForm, values
                }) => (
                    <Form>
                        <h2>{nomeRelatorio}</h2>

                        <Calendar
                            name="competencia"
                            dateFormat="mm/yy"
                            view="month"
                            label="Competência"
                            containerStyle={{ gridArea: 'f1' }}
                            tooltip={`<p>Com o calendário aberto, selecione a primeira data,<br/>em seguida, a segunda.</p><br/><img src="${rangeMonthGif}" style="width:300px; height:auto" />`}
                        />

                        <Select
                            name="instituicao"
                            label="Instituição"
                            onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                            options={instituicoes.filter(insti => insti.desconto).map(instituicao => ({
                                label: `${instituicao.nome_fantasia} ${instituicao.sigla ? `(${instituicao.sigla})` : ''}`,
                                value: instituicao.id
                            }))}
                            containerStyle={{ gridArea: 'f2' }}
                        />

                        {/* <Select
                            name="plano-saude-status"
                            label="Plano de Saúde"
                            onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                            options={[
                                { label: 'Com plano', value: 1 },
                                { label: 'Sem plano', value: 2 }
                            ]}
                            containerStyle={{ gridArea: 'f3' }}
                        /> */}

                        {/* <Select
                            name="juridico"
                            label="Causas no Jurídico"
                            onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                            options={[
                                { label: 'Com causa', value: 1 },
                                { label: 'Sem causa', value: 2 }
                            ]}
                            containerStyle={{ gridArea: 'f4' }}
                        /> */}

                        <Select
                            name="cidade"
                            label="Cidade"
                            onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                            options={cidades.map(cidade => ({
                                label: cidade,
                                value: cidade
                            }))}
                            containerStyle={{ gridArea: 'f5' }}
                        />

                        {/* <Calendar
                            name="data-nascimento"
                            dateFormat="dd/mm/yy"
                            label="Data de Nascimento"
                            selectionMode="range"
                            maxDate={new Date(new Date().getFullYear() - 14, 11, 31)}
                            yearRange={`${new Date().getFullYear() - 100}:${new Date().getFullYear() - 14}`}
                            containerStyle={{ gridArea: 'f6' }}
                            tooltip={`<p>Com o calendário aberto, selecione a primeira data,<br/>em seguida, a segunda.</p><br/><img src="${rangeDayGif}" style="width:300px; height:auto" />`}
                        /> */}

                        {/* <Calendar
                            name="aniversario"
                            dateFormat="dd/mm"
                            label="Data de Aniversário"
                            yearNavigator={false}
                            containerClass="header-without-year"
                            selectionMode="range"
                            containerStyle={{ gridArea: 'f7' }}
                            tooltip={`<p>Com o calendário aberto, selecione a primeira data,<br/>em seguida, a segunda.</p><br/><img src="${rangeDayGif}" style="width:300px; height:auto" />`}
                        /> */}

                        <Spinner
                            visible={isSubmitting}
                            label="Gerando relatório..."
                        />

                        <ButtonContainer>
                            <Button
                                onClick={resetForm}
                                className="transparent"
                            >
                                Limpar
                            </Button>

                            <Button
                                onClick={() => handleSubmitPlanilha(values, resetForm)}
                                loading={isSubmittingPlanilha}
                                className="white"
                            >
                                Gerar planilha
                                <FiFileText size={20} />
                            </Button>

                            <Button
                                type="submit"
                                loading={isSubmitting}
                                className="white"
                            >
                                Gerar relatório
                                <FiFile size={20} />
                            </Button>
                        </ButtonContainer>
                    </Form>
                )}
            </Formik>
        </Container>
    )
}
